export const routes = {
  index: '/',
  login: '/login',
  dashboard: '/dashboard',
  users: '/users',
  clientCompanies: '/client-companies',
}
